module.exports = __webpack_public_path__ + "media/images/mymp-logo-dark-bb2524ce63782addf02bb547e8efa9cc.svg";